import React from 'react';
import Reflux from 'reflux';
import HeaderStore from '../../stores/header';
import Header from '../../components/header';

export default class NewHeader extends Reflux.Component {
  constructor (props) {
    super(props);
    this.store = HeaderStore;
  }

  render () {
    return <Header {...this.state} />;
  }
};



// WEBPACK FOOTER //
// ./frontend/react/apps/head/index.js